module.exports = __webpack_public_path__ + "media/50.367d430e.wav";